<script setup>
import { computed } from "vue";
import { useMainStore } from "@/store/MainStore.js";

const store = useMainStore();
const isNavFixed = computed(() => store.isNavFixed);
const darkMode = computed(() => store.darkMode);

defineProps({
  currentPage: {
    type: String,
    default: "",
  },
  currentDirectory: {
    type: String,
    default: "",
  },
});
</script>
<template>
  <nav aria-label="breadcrumb">
    <ol
      class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb"
      :class="`${isNavFixed ? 'text-dark' : 'text-white'}`"
    >
      <li class="text-sm breadcrumb-item">
        <a
          :class="darkMode ? 'text-warning' : 'text-dark'"
          class="opacity-8"
          href="/dashboard"
          >Calid</a
        >
      </li>
      <li
        class="text-sm breadcrumb-item active"
        :class="darkMode ? 'text-light' : 'text-dark'"
        aria-current="page"
      >
        {{ currentDirectory }}
      </li>
    </ol>
    <h6
      class="mb-0 font-weight-bolder"
      :class="isNavFixed ? 'text-dark' : 'text-white'"
    >
      {{ currentPage }}
    </h6>
  </nav>
</template>
